import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
function TimelineStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6;
  var _getThemeData2 = getThemeData(props, 'timeline'),
    fontSize = _getThemeData2.fontSize,
    fontColor = _getThemeData2.fontColor,
    borderColor = _getThemeData2.borderColor;
  return css([".c7n-timeline.c7n-timeline{color:", ";.c7n-timeline-item{font-size:", "px;.c7n-timeline-item-head{&.c7n-timeline-item-head-blue{border-color:", " !important;}}.c7n-timeline-item-tail{border-left:0.02rem solid ", ";}}}"], fontColor, fontSize, primary6, borderColor);
}
export default TimelineStyle;